import { Box, Container, Typography, Button } from '@mui/material'
import { RouteObject } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

export const logoutRoute: RouteObject = {
  path: '/logout',
  element: <Logout />,
}

function Logout() {
  const { loginWithRedirect } = useAuth0()

  const handleLogin = () => {
    try {
      loginWithRedirect()
    } catch (error) {
      // Fallback: redirect to home which will trigger auth required
      window.location.href = '/'
    }
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: '8rem',
            mb: 2,
          }}
        >
          🐔
        </Typography>
        <Typography variant="h4" sx={{ mb: 1 }}>
          You've been logged out
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Thanks for using FlockFocus!
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={handleLogin}
          sx={{ mt: 2 }}
        >
          Log In Again
        </Button>
      </Box>
    </Container>
  )
}

export default Logout
